import useConstant from "use-constant";
import { isNativeIOS } from "~/utils/pwaBuilder-utils";

export function useIsNativeIOS() {
  return useConstant(isNativeIOS);
}
